import { Options, Vue } from 'vue-class-component';
import Toggle from '@vueform/toggle';

import * as ContactTypeService from '@/services/contact-type.service';
import { IContactType } from '@/domain/contact-type.model';

@Options({
  name: 'contact-type-edit',
  props: {
    id: String,
  },
  components: {
    Toggle,
  },
})
export default class ContactTypeEdit extends Vue {
  public id: string;
  public errorMessage = '';
  public errors: any = {};
  public hasError = false;
  public row: IContactType = {
    description: '',
    enabled: false,
  };

  public mounted(): void {
    ContactTypeService.get(this.id)
      .then((res: IContactType) => {
        if (res && res.id) {
          this.row = res;
        } else {
          this.errorMessage = 'Registro não encontrado.';
        }
      })
      .catch(() => {
        this.errorMessage = 'Registro não encontrado.';
      });
  }

  public goBack() {
    this.$router.push('/contact-type');
  }

  public validation() {
    this.errors = {};
    this.hasError = false;

    if (!this.row.description) {
      this.errors.description = 'Este campo deve ser preenchido.';
      this.hasError = true;
    }

    return !this.hasError;
  }

  public save() {
    if (this.validation()) {
      ContactTypeService.update({
        id: parseInt(this.id),
        description: this.row.description,
        enabled: this.row.enabled,
      })
        .then(() => {
          this.$router.push('/contact-type');
        })
        .catch(() => {
          this.errorMessage = 'Ocorreu um erro ao gravar o registro.';
        });
    }
  }
}
